/**
 * 按钮权限控制
 * eg: v-btnPermission="'1_ADD'"
 * '1_ADD' 为按钮对应的code值
 */

import btnPermission from './btnPermission.js'
const install = function(Vue) {
  Vue.directive('btnPermission', btnPermission)
}

if (window.Vue) {
  window['btnPermission'] = btnPermission
    Vue.use(install); // eslint-disable-line
}

btnPermission.install = install
export default btnPermission
